import React from 'react'

type BadgeType = {
    children: string,
    gradColor1: string,
    gradColor2: string,
    BgColor: string
}

const ComingSoonBadge = ({ children, gradColor1, gradColor2, BgColor }: BadgeType) => {
    return (
        <div
            className="shadow-[0px_4px_4px_0px_#CECECE40] absolute md:-top-[20px] -top-[10px] md:-right-[20px] -right-[15px] rotate-[24.87deg] md:p-[6px] p-[4px] rounded-[32px]"
            style={{ background: `linear-gradient(to right, ${gradColor1}, ${gradColor2})` }}
        >
            <span
                className="md:p-[4px] p-[2px] rounded-[32px] font-inter text-[#010721] text-nowrap md:text-[9px] text-[5px] font-[400] flex items-center justify-center"
                style={{ backgroundColor: BgColor }}
            >
                {children}
            </span>
        </div>
    )
}

export default ComingSoonBadge